import React, {FC} from 'react'
import { useDispatch } from 'react-redux'

//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { constants as DCConstants } from '../../../DetailsContainer'

import { translateOfficerAdd } from '../../translator'
import OfficerTable from './Officer'
import OfficerAssistantTable from './OfficerAssistant'

import { LoanOfficerAdd, LoanOfficerAssistantAdd, constants } from '../../../LoanOfficerAdd'
import { OfficerProps } from '../../types.LoanDetails'

const Officer: FC<OfficerProps> = ({ ID, hash, data: { base, officer, officerassistant } }) => {
  const dispatch = useDispatch()

  const createModalOpener = (name: string) => () => {
    dispatch(LKModalActions.open({ name }))
  }

  return (
    <>
      {/* @ts-ignore */}
      <LoanOfficerAdd ID={ID} hash={hash} base={base} />
      {/* @ts-ignore */}
      <LoanOfficerAssistantAdd ID={ID} hash={hash} base={base} />

      <div className="u-flex u-directionColumn u-fluid">
        <div className="u-fluid u-flex">
          <div className="u-fluid u-relative">
            <OfficerTable
              instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Officers`}
              data={officer}
              base={base}
              ID={ID}
              hash={hash}
            />
          </div>

          <div className="u-fluid u-relative">
            <OfficerAssistantTable
              instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-OfficerAssistants`}
              data={officerassistant}
              ID={ID}
              hash={hash}
              base={base}
            />
          </div>
        </div>

        {base.IsArrested !== 1 && (
          <div className="u-flex u-spaceBetween u-padding-5">
            <LKButton onClick={createModalOpener(constants.type.officer)} alias="add" permission="LOAN_ADD_OFFICER">
              {translateOfficerAdd('cmd_finish')}
            </LKButton>

            <LKButton onClick={createModalOpener(constants.type.assistant)} alias="add" permission="LOAN_ADD_OFFICER">
              {translateOfficerAdd('cmd_finish')}
            </LKButton>
          </div>
        )}
      </div>
    </>
  )
}

export default React.memo(Officer)
